import { render, staticRenderFns } from "./Ritual.vue?vue&type=template&id=b6bf712a&scoped=true"
import script from "./Ritual.vue?vue&type=script&lang=js"
export * from "./Ritual.vue?vue&type=script&lang=js"
import style0 from "./Ritual.vue?vue&type=style&index=0&id=b6bf712a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bf712a",
  null
  
)

export default component.exports